var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0.75C11.8752 0.752399 9.01929 2.51831 7.62094 5.31281C5.39765 4.98856 3.17951 5.93363 1.87326 7.76171C0.567001 9.58978 0.391555 11.9945 1.41864 13.9928C2.44572 15.9911 4.50319 17.2481 6.75 17.25H15C19.5563 17.25 23.25 13.5563 23.25 9C23.25 4.44365 19.5563 0.75 15 0.75ZM15 15.75H6.75C4.26472 15.75 2.25 13.7353 2.25 11.25C2.25 8.76472 4.26472 6.75 6.75 6.75C6.85313 6.75 6.95625 6.75 7.05844 6.76031C6.85333 7.48918 6.74955 8.24282 6.75 9C6.75 9.41421 7.08579 9.75 7.5 9.75C7.91421 9.75 8.25 9.41421 8.25 9C8.25 5.27208 11.2721 2.25 15 2.25C18.7279 2.25 21.75 5.27208 21.75 9C21.75 12.7279 18.7279 15.75 15 15.75Z",
    fill: "#082C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.3419f0fff9fed3fe977fb5c108fb5f9c.svg";
export { ForwardRef as ReactComponent };